import { render, staticRenderFns } from "./PelleUpgrade.vue?vue&type=template&id=ca6136a8&scoped=true"
import script from "./PelleUpgrade.vue?vue&type=script&lang=js"
export * from "./PelleUpgrade.vue?vue&type=script&lang=js"
import style0 from "./PelleUpgrade.vue?vue&type=style&index=0&id=ca6136a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6136a8",
  null
  
)

export default component.exports